import React from 'react';

import Skeleton from 'components/Skeleton';

import { GUIDE_HEIGHT, TITLE_HEIGHT, TITLE_WIDTH } from './constants';

const GuidesSkeleton = () => (
    <>
        <Skeleton width={TITLE_WIDTH} height={TITLE_HEIGHT} mb={8} />
        <Skeleton height={GUIDE_HEIGHT} mb={12} />
        <Skeleton height={GUIDE_HEIGHT} mb={12} />
    </>
);

export default GuidesSkeleton;
